import { formatterPercentage, normaliseCurrencyISO } from '@/utilities/format';
import { Scale, toCurrency, toCurrencyTruncated } from '@/utilities/formatting';

export const formatCurrencyToScaleTruncated = (
  value?: number | null,
  iso?: string
) => {
  if (value === undefined || value === null) {
    return 'n/a';
  }

  if (value >= Scale.Millions || value <= -Scale.Millions) {
    return toCurrencyTruncated(value, 2, normaliseCurrencyISO(iso));
  }

  if (value >= Scale.Thousands || value <= -Scale.Thousands) {
    return toCurrency(value, 0, normaliseCurrencyISO(iso));
  }

  if (value >= Scale.Hundreds || value <= -Scale.Hundreds) {
    return toCurrencyTruncated(value, 0, normaliseCurrencyISO(iso));
  }

  return toCurrency(value, 2, normaliseCurrencyISO(iso));
};

export const formatCurrencyTruncatedWithSign = (
  value?: number | null,
  iso?: string
) => {
  const formattedValue = formatCurrencyToScaleTruncated(
    value,
    normaliseCurrencyISO(iso)
  );
  if (value && value > 0) {
    return `+${formattedValue}`;
  }
  return formattedValue;
};

export const formatPercentageWithSign = (value?: number | null) => {
  const formattedValue = formatterPercentage(value);
  if (value && value > 0) return `+${formattedValue}`;
  return formattedValue;
};
